import { useState } from 'react'
import InputText from 'global/InputText/InputText'
import SimpleButton from 'global/SimpleButton/SimpleButton'
import { toast } from 'react-toastify'
import { getAPI } from 'services/CRUDServices'
import { BsCheckCircleFill, BsXCircleFill } from 'react-icons/bs'

const ProductIdsValidation = ({ formik, nationalId }) => {
  const { values, handleChange, touched, errors } = formik

  const [goodsIdStatus, setGoodsIdStatus] = useState('idle')
  const [ircIdStatus, setIrcIdStatus] = useState('idle')

  const checkGoodsId = async () => {
    if (!values.goodsId) return toast.error('لطفا شناسه کالا را وارد کنید')

    setGoodsIdStatus('loading')
    try {
      await getAPI(`/customer-api/customer/shenaseKala/${values.goodsId}`)
      setGoodsIdStatus('valid')
    } catch (error) {
      setGoodsIdStatus('invalid')
    }
  }

  const checkIrcId = async () => {
    if (!values.ircId) return toast.error('لطفا شناسه غذا و دارو را وارد کنید')
    if (!nationalId) return toast.error('لطفا کد ملی فرستنده را وارد کنید')

    setIrcIdStatus('loading')
    try {
      await getAPI(
        `/customer-api/customer/gazaVaDaro/${values.ircId}/${nationalId}`
      )
      setIrcIdStatus('valid')
    } catch (error) {
      setIrcIdStatus('invalid')
    }
  }

  const renderStatusIcon = (status) => {
    switch (status) {
      case 'valid':
        return <BsCheckCircleFill className='text-green' size={22} />
      case 'invalid':
        return <BsXCircleFill className='text-red' size={22} />
      default:
        return null
    }
  }

  const handleInputChange = (e) => {
    handleChange(e)
    if (e.target.name === 'goodsId') setGoodsIdStatus('idle')
    if (e.target.name === 'ircId') setIrcIdStatus('idle')
  }

  return (
    <>
      <div className='flex  gap-2 w-full  items-center'>
        <InputText
          classNames={`bg-white ${
            goodsIdStatus === 'valid' ? 'border-green' : ''
          } ${goodsIdStatus === 'invalid' ? 'border-red' : ''}`}
          label='شناسه کالا'
          name='goodsId'
          handleChange={handleInputChange}
          values={values.goodsId}
          error={
            (touched.goodsId && errors.goodsId) ||
            (goodsIdStatus === 'invalid' ? 'کد نامعتبر است' : '')
          }
          wrapperClassName='w-full'
          leftIcon={renderStatusIcon(goodsIdStatus)}
          readOnly={goodsIdStatus === 'loading'}
          hiddenError
        />{' '}
        <SimpleButton
          text='بررسی'
          handelClick={checkGoodsId}
          loading={goodsIdStatus === 'loading'}
          disabled={goodsIdStatus === 'loading'}
          className=' border border-tomato bg-white '
          loadingColor='tomato'
        />
      </div>

      <div className='flex  gap-2 w-full  items-center'>
        <InputText
          classNames={`  bg-white ${
            ircIdStatus === 'valid' ? 'border-green ' : ''
          } ${ircIdStatus === 'invalid' ? 'border-red' : ''}`}
          label='شناسه غذا و دارو'
          name='ircId'
          handleChange={handleInputChange}
          values={values.ircId}
          error={
            (touched.ircId && errors.ircId) ||
            (ircIdStatus === 'invalid' ? 'کد نامعتبر است' : '')
          }
          wrapperClassName='w-full'
          leftIcon={renderStatusIcon(ircIdStatus)}
          readOnly={ircIdStatus === 'loading'}
          hiddenError
        />

        <SimpleButton
          text='بررسی'
          handelClick={checkIrcId}
          loading={ircIdStatus === 'loading'}
          disabled={ircIdStatus === 'loading'}
          className=' border border-tomato bg-white '
          loadingColor='tomato'
        />
      </div>
    </>
  )
}

export default ProductIdsValidation
